import React from "react";
import { Typography } from "@material-ui/core";

const SessionHelpText = () => {
  return (
    <div>
      <Typography variant="body2">
          Export organization details on individual patron sessions by month, broken down by
          browser type (Web, iOS, Android, Amazon Fire and Total).
      </Typography>
    </div>
  );
};

export default SessionHelpText;
